export class TibiaAnalyzerAPConfig {
}
TibiaAnalyzerAPConfig.LP_color = 0x63ADF2;
TibiaAnalyzerAPConfig.MP_color = 0x63ADF2;
TibiaAnalyzerAPConfig.LA_color = 0x63ADF2;
TibiaAnalyzerAPConfig.MA_color = 0x63ADF2;
TibiaAnalyzerAPConfig.CP_color = 0x63ADF2;
TibiaAnalyzerAPConfig.CA_color = 0x63ADF2;
TibiaAnalyzerAPConfig.apex_color = 0xFF0000;
TibiaAnalyzerAPConfig.apexLabel_backgroundColor = 'rgba(255, 255, 0, 0.6)';
TibiaAnalyzerAPConfig.apexLabel_fontColor = '#ffffff';
TibiaAnalyzerAPConfig.anatomicalAxis_color = 0x63ADF2;
TibiaAnalyzerAPConfig.LP_MP_Line_color = 0x63ADF2;
TibiaAnalyzerAPConfig.LA_MA_Line_color = 0x63ADF2;
TibiaAnalyzerAPConfig.proximalMechanicalAxis_color = 0xFFFF00;
TibiaAnalyzerAPConfig.distalMechanicalAxis_color = 0xFFFF00;
TibiaAnalyzerAPConfig.MPTALabel_backgroundColor = 'rgba(0, 0, 0, 0.6)';
TibiaAnalyzerAPConfig.MPTALabel_fontColor = '#ffffff';
TibiaAnalyzerAPConfig.LDTALabel_backgroundColor = 'rgba(0, 0, 0, 0.6)';
TibiaAnalyzerAPConfig.LDTALabel_fontColor = '#ffffff';
//# sourceMappingURL=TibiaAnalyzerAPConfig.js.map